import firebase from "firebase";

const config = {
  apiKey: "AIzaSyA6YrBSkDb-hAwWZDaYZmSSQvyE1X5Ff0o",
  authDomain: "ovileamriam.firebaseapp.com",
  databaseURL: "https://ovileamriam.firebaseio.com",
  projectId: "ovileamriam",
  storageBucket: "ovileamriam.appspot.com",
  messagingSenderId: "983860008574",
  appId: "1:983860008574:web:b999fc3ff4c36416c0aa2f",
  measurementId: "G-DG5ME8QZXR"
};
firebase.initializeApp(config);
